"use client";
import * as React from "react";
import FeatureList from "./FeatureList";
import BusinessIllustration from "./BusinessIllustration";

function EmpoweringSMMEs() {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css"
      />
      <div className="flex w-full bg-white min-h-screen max-md:flex-col">
        <div className="flex md:order-1 order-2 flex-col flex-1 justify-center px-20 py-16 max-md:p-10 max-sm:px-5">
          <div className="max-w-[600px]">
            <h1 className="mb-4 text-6xl font-bold leading-tight text-teal-500 max-md:text-5xl max-sm:text-4xl">
              Empowering SMMEs
            </h1>
            <h2 className="mb-8 text-xl leading-snug text-amber-500 max-sm:text-lg">
              Enterprise-grade power, simplified.
            </h2>
            <p className="mb-10 text-base leading-relaxed text-zinc-800 max-sm:text-base">
              High-end business tools shouldn't be reserved for the giants. We
              provide small and medium enterprises with the same operational
              power used by global corporations, condensed into an intuitive
              platform that fits your scale and your budget. Competitive
              advantage, democratized.
            </p>
            <FeatureList />
          </div>
        </div>
        <div className="flex md:order-2 order-1 flex-1 justify-center items-center p-10 max-md:p-5">
          <div className="relative w-full max-w-[600px]">
            <BusinessIllustration />
          </div>
        </div>
      </div>
    </>
  );
}

export default EmpoweringSMMEs;
